import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthCheckService } from 'src/app/auth/services/auth-check.service';

export const authGuard: CanActivateFn = (_route, state) => {
    const authCheckService = inject(AuthCheckService);
    const router = inject(Router);

    if (authCheckService.isLogged) {
        return true;
    }

    router.navigate(['/login'], {
        queryParams: { returnUrl: state.url },
    });
    return false;
};
